/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { ControlledCustomSelect } from "../formsComponents";
import { api } from "../../api/api";

export interface ILeadSourceFilterProps {
  value: string;
  onChange: (value: string) => void;
  isHighlighted?: boolean;
}

export const LeadSourceFilter: React.FC<ILeadSourceFilterProps> = (props) => {
  const { value, isHighlighted, onChange } = props;
  const [options, setOptions] = React.useState<readonly string[]>([]);

  const fetchSuggestion = async () => {
    try {
      const res = await api.get(
        `/general/get-distinct-column-values?table_name=latest_action_item&column_name=source`,
      );
      const data: string[] = res.data.data || [];
      setOptions(data);
    } catch (error) {
      console.error("Error fetching lead source list:", error);
    }
  };

  useEffect(() => {
    fetchSuggestion();
  }, []);

  return (
    <ControlledCustomSelect
      label="Source"
      labelId="lead-source"
      fullWidth
      clearable={!!value}
      sx={{
        minWidth: "120px",
        ...(isHighlighted && {
          backgroundColor: "#fff2c7",
          borderRadius: 1,
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "warning.main",
            borderWidth: "2px !important",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "warning.main",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "warning.main",
          },
        }),
      }}
      displayEmpty
      value={value}
      options={options
        .filter((opt) => opt && opt.trim() !== "")
        .map((opt) => ({
          label: opt,
          value: opt,
        }))}
      onChange={(e) => onChange(e.target.value as string)}
      onClear={() => onChange("")}
    />
  );
};

